import { Component, OnInit, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { AssociateService } from '@app/_services/associate.service';
import { DocumentVerificationListService } from '@app/_services/document-verification-list.service';
import { environment } from '@environments/environment';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { first } from 'rxjs/operators';
import { LogService } from '../../_shared/log.service';
import * as XLSX from 'xlsx';
import { excelData } from '@app/_models/excelData';

declare var $: any;

@Component({
  selector: 'app-associate-add-record',
  templateUrl: './associate-add-record.component.html',
  styleUrls: ['./associate-add-record.component.css']
})
export class AssociateAddRecordComponent implements OnInit {

  excelFile;
  showImagePrev = false;
  showPdfPrev = false;
  showPreview = false;
  isUPdf: boolean = false;
  isUImage: boolean = false;
  formData = new FormData();
  reviewedData: excelData[] = [];
  rejectedData = [];
  acceptedData = [];
  pdfSrc;
  showExcelPreview = false;
  pdfSizeErr = false;
  excelSizeErr = false;
  fileToUpload: any;
  imageUrl: any;
  enterMarksErr = false;
  enterExcelErr = false;
  IsmodelShow;
  IsmodelShowSecond;
  emptyExcel = false;
  scanMsg;
  fileURL;
  filepreview;
  arrayBuffer;
  filelist;
  arraylist: excelData[] = [];
  uploadedFilePath;
  filePath;
  allowConfirm;
  // showPreview;

  @ViewChild('closebutton1') closebutton1;
  @ViewChild('closebutton2') closebutton2;
  @ViewChild('inputFile1') myInputVariable1: ElementRef;
  @ViewChild('inputFile2') myInputVariable2: ElementRef;
  @ViewChild('showModalBox', { read: TemplateRef }) showModalBoxTemplate: TemplateRef<any>;
  @ViewChild('showModalBox1', { read: TemplateRef }) showModalBox1Template: TemplateRef<any>;

  constructor(private eventService: LogService, private associateService: AssociateService, private modalService: NgbModal,) {

  }

  ngOnInit(): void {
    this.IsmodelShow = false;
    this.IsmodelShowSecond = false;
  }

  callDispute(dataValue) {
    this.eventService.emit<string>(dataValue)
  }

  pdfOnload(event) {
    const pdfTatget: any = event.target;
    if (typeof FileReader !== 'undefined') {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
        console.log("--------this.pdfSrc---------", this.pdfSrc)
        this.imageUrl = this.pdfSrc;
      };
      // this.pdfBufferRender = pdfTatget.files[0];
      reader.readAsArrayBuffer(pdfTatget.files[0]);
    }
    // this.isEmptyDrop = false;
    // this.isExcelDrop = false;
  }

  catchPdf(event) {
    this.enterMarksErr = false;
    console.log("TYPE---", event.target.files[0].type)
    if (event.target.files[0].type === "application/pdf") {
      this.showPdfPrev = true;
      this.showImagePrev = false;
    } else {
      this.showImagePrev = true;
      this.showPdfPrev = false;
    }
    if (event.target.files[0].size > 768000) {
      //750*1024=768000
      console.log("File size must be less than 750KB.")
      this.pdfSizeErr = true;
    } else {
      this.pdfSizeErr = false;
      const pdfTatget: any = event.target;
      if (typeof FileReader !== 'undefined') {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.pdfSrc = e.target.result;
          // console.log("--------this.pdfSrc---------",this.pdfSrc)
          this.imageUrl = this.pdfSrc;
        };
        // this.pdfBufferRender = pdfTatget.files[0];
        reader.readAsArrayBuffer(pdfTatget.files[0]);
      }


      var files = event.target.files
      this.fileToUpload = ''
      console.log("files-------", files);
      this.fileToUpload = files.item(0);
      this.fileURL = files;
      this.filepreview = files[0];
      let reader = new FileReader();
      reader.onload = (event: any) => {
        this.imageUrl = event.target.result;
        // this.pdfUrl = event.target.result;
      }
      reader.readAsDataURL(this.fileToUpload);

      // console.log(files)
      // console.log(files.item(0))

      this.formData.delete('file');
      console.log(">>>>fileToUpload>>>>>>--------", this.fileToUpload);
      this.formData.append("file", this.fileToUpload);
      this.associateService.associateFileSave(this.formData)
        .pipe(first())
        .subscribe(
          data => {
            console.log("file---upload---response---", data)
            this.filePath = data.respData;
            // this.updateData(data.respData);
            for (var j = 0; j < this.arraylist.length; j++) {
              this.reviewedData[j].originalDOCuploadfilePath = this.filePath;
            }
            console.log(">>>>>>>>>>--------", this.reviewedData);
          },
          error => {
            console.log(error)
          }
        )
    }
    // console.log(this.formData);
    // if (this.enterExcelErr == true || this.pdfSizeErr == true || this.excelSizeErr == true) {
    //   this.allowConfirm = true;
    // } else {
    //   this.allowConfirm = false;
    // }

  }

  // updateData(filepath){

  //   console.log("final reviewedData------", this.reviewedData);
  // }

  catchExcel(event) {
   
    this.reviewedData = [];
    if (event.target.files[0].size > 768000) {
      this.excelSizeErr = true;
      
    } else {
      this.excelSizeErr = false;
      // this.formData.append("excelfile", files.item(0));
      this.enterExcelErr = false;
      this.excelFile = event.target.files[0];


      let fileReader = new FileReader();
      fileReader.readAsArrayBuffer(this.excelFile);
      fileReader.onload = (e) => {
        this.arrayBuffer = fileReader.result;
        var data = new Uint8Array(this.arrayBuffer);
        var arr = new Array();
        for (var i = 0; i != data.length; ++i) {
          arr[i] = String.fromCharCode(data[i]);
        }
        var bstr = arr.join("");
        var workbook = XLSX.read(bstr, { type: "binary" });
        var first_sheet_name = workbook.SheetNames[0];
        var worksheet = workbook.Sheets[first_sheet_name];
        console.log(XLSX.utils.sheet_to_json(worksheet, { raw: true }));
        this.arraylist = XLSX.utils.sheet_to_json(worksheet, { raw: true });
        this.filelist = [];


        const columnCount = XLSX.utils.decode_range(worksheet['!ref']).e.c + 1
        if (columnCount > 5 || columnCount < 5) {
          this.emptyExcel = true;
        }
        else {
          this.emptyExcel = false;
          this.formData.delete('file');
          this.formData.append("file", this.fileToUpload);
          this.associateService.associateFileSave(this.formData)
            .pipe(first())
            .subscribe(
              data => {
                console.log("file---upload---response---", data)
                this.filePath = data.respData;
               
              },
              error => {
                console.log(error)
              }
            )
          
          for (var j = 0; j < this.arraylist.length; j++) {
            var v: excelData[] = [];
            this.reviewedData.push({
              enrollmentNo: this.arraylist[j]['Seat No.'],
              stream: this.arraylist[j]['Degree'],
              passingYear: this.arraylist[j]['YearOfPassing'],
              monthOfPassing: this.arraylist[j]['MonthOfPAssing'],
              semester: this.arraylist[j]['Semester'],
              originalDOCuploadfilePath: this.filePath
            });
          }
          console.log("---reviewedData---", this.reviewedData);
        }
      }

    }
    // if (this.enterMarksErr == true || this.pdfSizeErr == true || this.excelSizeErr == true) {
    //   this.allowConfirm = true;
    // } else {
    //   this.allowConfirm = false;
    // }
  }

  openPdf() {
    window.open(this.fileURL);
  }

  reviewRecord() {
    console.log("this.enterExcelErr", this.enterExcelErr)
    console.log("this.pdfSizeErr", this.pdfSizeErr)
    console.log("this.excelSizeErr", this.excelSizeErr)
    console.log("this.enterMarksErr", this.enterMarksErr)
    this.showPreview = true;
  
    console.log("============", this.excelFile)
    for (var j = 0; j < this.arraylist.length; j++) {
      this.reviewedData[j].originalDOCuploadfilePath = this.filePath;
    }
    if (this.excelFile != undefined) {
      this.enterExcelErr = false;
      // this.enterMarksErr = false;
     
    } else {
      console.log('Please enter student Excel File.')
      this.enterExcelErr = true;
      // this.enterMarksErr = true;
    }
    if (this.pdfSrc != undefined) {      
      this.enterMarksErr = false;
     
    } else {
      console.log('Please enter student Excel File.')      
       this.enterMarksErr = true;
    }
    

    if (this.enterExcelErr == true || this.enterMarksErr == true || this.pdfSizeErr == true || this.excelSizeErr == true) {
      this.allowConfirm = true;
    } else {
      this.allowConfirm = false;
    }
    if (this.enterExcelErr == true && this.enterMarksErr == true)
    {
      this.showExcelPreview = false;
    }
    else if((this.enterExcelErr == false && this.enterMarksErr == false))
    {
      this.showExcelPreview = true;
    }
    else
    {
      this.showExcelPreview = false;
    }
  }

  confirmData() {
    this.IsmodelShowSecond = true;
    let associateId = localStorage.getItem('user_id');
    console.log("revieweddata---------", this.reviewedData)
    console.log("associateId----------", associateId)
    
    this.allowConfirm = false;
    this.associateService.confirmAssociateDocs(this.reviewedData, associateId)
      .pipe(first())
      .subscribe(
        data => {
          console.log("reviewed data --->", data)
          this.rejectedData = data.respData.RejectedData;
          this.acceptedData = data.respData.savedStudentData;
        },
        error => {
          console.log(error)
        }
      )    
  }

  cancelData() {
    // previewModal.close
    this.showExcelPreview = false;
    location.reload();
    this.formData.delete;
    //  this. callDispute(1)
    this.IsmodelShow = false;
    this.IsmodelShowSecond = false;
    this.formData = new FormData();;
    this.closebutton1.nativeElement.click();
    // this.closebutton2.nativeElement.click();
    this.myInputVariable1.nativeElement.value = null;
    this.myInputVariable2.nativeElement.value = null;
  }

  closeAll() {
    // this.formData.delete;
    // //  this. callDispute(1)
    // this.IsmodelShow = false;
    // this.IsmodelShowSecond = false;
    // this.formData = new FormData();;
    // // this.formData.get('datafile') .toString== null

    // // this.formData.get('excelfile').valueOf('name').toString== null
    // this.closebutton1.nativeElement.click();
    // this.closebutton2.nativeElement.click();
    // this.myInputVariable1.nativeElement.value = null;
    // this.myInputVariable2.nativeElement.value = null;
    // this.myInputVariable1.nativeElement.value = '';
    // this.myInputVariable2.nativeElement.value = '';
    // this.myInputVariable1.nativeElement.reset();
    // this.myInputVariable2.nativeElement.reset();
    // var files: FileList
    // // this.formData.set('excelfile')=null; 
    // this.formData.append("datafile", files.item(0));
    // this.formData.append("excelfile", files.item(0));
    // this.rejectedData = [];
    // this.acceptedData = [];
    location.reload();
  }
  funAutoReadExcel() {
    this.associateService.autoExcelReading()
      .pipe(first())
      .subscribe(
        data => {
          console.log("reviewed data --->", data)
          this.scanMsg = data.respData;
          if (this.scanMsg == "Added data successfully, Rejected Data sent via mail") {
            this.modalService.open(this.showModalBoxTemplate);
          }
          if (this.scanMsg == "Added data succefully,No data is Rejected from this file") {
            this.modalService.open(this.showModalBoxTemplate);
          }
          if (this.scanMsg == "Process already active!") {
            this.modalService.open(this.showModalBox1Template);
          }
          if (this.scanMsg == "File not found to read data") {
            this.modalService.open(this.showModalBoxTemplate);
          }
          if (this.scanMsg == "Unable to read file,check file format/Data and try again!") {
            this.modalService.open(this.showModalBoxTemplate);
          }
        },
        error => {
          console.log(error)
        }
      )
  }

  refresh(): void {
    location.reload();
    // this.modalService.dismissAll(this.showModalBoxTemplate);
    // this.eventService.emit<string>("0")
    // this.returnUrl = "employer";
    // this.router.navigate([this.returnUrl]);
  }

  refreshClose(): void {
    this.modalService.dismissAll(this.showModalBox1Template);
  }

}